module.exports = "/dist/src/img/icons/infoSymbol.png";